"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleModel = void 0;
const ide_lib_reactor_data_layer_1 = require("@journeyapps-platform/ide-lib-reactor-data-layer");
const BaseModel_1 = require("./base/BaseModel");
class RoleModel extends BaseModel_1.BaseModel {
    constructor(options) {
        super(options);
        this.policies = new ide_lib_reactor_data_layer_1.PaginatedCollection({
            transformer: (res) => {
                return res.items.map((p) => {
                    return {
                        role: this,
                        policy: options.banks.policyBank.upsert(p)
                    };
                });
            }
        });
    }
    get org() {
        return this.options.banks.orgBank.org(this.options.role.org_id);
    }
    getOrg() {
        return this.options.banks.orgBank.resolve(this.options.role.org_id);
    }
    async loadPolicies() {
        const client = this.options.clients.provisionCardinalClient();
        return this.policies.loadAll(() => {
            return client.listPolicies.paginate({
                id: this.options.role.policy_ids
            });
        });
    }
    get id() {
        return this.options.role.id;
    }
}
exports.RoleModel = RoleModel;
